import { pipelineId, writekey, clusterId } from '../fixture-ids';

export const pipelineEventLegacyAlternates = {};

export const pipelineEventLegacyFixtures = {
  // Legacy rows always carry the id/writekey pair (no conditional lookup branch); no `path`.
  PIPELINE_DEPLOYED: {
    action: 'PIPELINE_DEPLOYED',
    debugData: { pipelineId, pipelineName: 'Web Analytics', writekey, clusterId },
  },
  AJS_FILE_BUILT: { action: 'AJS_FILE_BUILT', debugData: { pipelineId, pipelineName: 'Web Analytics' } },
  STANDALONE_SYNC_FILE_BUILT: {
    action: 'STANDALONE_SYNC_FILE_BUILT',
    debugData: { pipelineId, pipelineName: 'Web Analytics' },
  },
  // The writer is useLogDeployment.js, not the orphaned hook; the value is a real writekey,
  // matching the core entry's entityField:'writekey' -- no map change needed, fixture only.
  AJS_FILE_UPLOADED: { action: 'AJS_FILE_UPLOADED', debugData: { writeKey: writekey } },
};
